import {createContext, useState} from "react";

export const GroupContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [groups, setGroups] = useState([]);

    // Make the context object:
    const groupContext = {
        groups,
        setGroups,
    };

    // pass the value in provider and return
    return <GroupContext.Provider value={groupContext}>{children}</GroupContext.Provider>;
}

export const {Consumer} = GroupContext;
